import ls from "localstorage-slim";
import { isNull } from "lodash";
import { strings } from "utils/localizeStrings";

export interface IFilterListCache {
  resetDataCache(key: string): void;
  setFilterCache(key: string, list: Array<unknown>): void;
  getFilterCache(key: string): void;
}

class FilterListCache implements IFilterListCache {
  filterCache: Array<string> = [
    "variant",
    "supplier",
    "category",
    "storage",
    "goods",
    "inventory",
    "wallet",
    "field",
    "partner",
    "role",
    "users",
  ];

  resetDataCache(key: string = "all") {
    ls.config.encrypt = true;
    if (key === "all") {
      this.filterCache.forEach((child) => ls.remove(child));
    } else if (this.filterCache.find((child) => child === key)) {
      ls.remove(key);
    } else {
      return;
    }
  }

  setFilterCache(key: string, list: Array<unknown>) {
    ls.config.encrypt = true;
    if (this.filterCache.find((child) => child === key)) {
      ls.set(key, JSON.stringify(list));
    } else {
      throw Error(strings.GlobalMessage.Error);
    }
  }

  getFilterCache(key: string) {
    ls.config.encrypt = true;
    if (
      this.filterCache.find((child) => child === key) &&
      !isNull(JSON.parse(ls.get(key)))
    ) {
      return JSON.parse(ls.get(key) as string);
    } else {
      return null;
    }
  }
}

export const useFilterListCache = new FilterListCache();
